import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
};
export const LoungeIcon = (props: Props) => {
    const { width = 40, height = 41, fill = 'currentColor', ...restProps } = props;
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 40 40" {...restProps} fill="none">
            <path d="M20 24.8851V14.8047C20 13.1478 18.6569 11.8047 17 11.8047H9.91907C8.26221 11.8047 6.91907 13.1478 6.91907 14.8047L6.91907 19.0266" stroke={fill} stroke-width="1.2"/>
            <path d="M33.0809 19.0266V14.8047C33.0809 13.1478 31.7378 11.8047 30.0809 11.8047H23C21.3431 11.8047 20 13.1478 20 14.8047V24.8851" stroke={fill} stroke-width="1.2"/>
            <path d="M7.32381 19.0195C9.04605 19.0195 10.4422 20.4158 10.4423 22.1381V24.8476H29.5578V22.1381C29.5579 20.4158 30.954 19.0195 32.6763 19.0195H33.1657C34.888 19.0195 36.2842 20.4158 36.2843 22.1381V27.0547C36.2842 28.777 34.888 30.1733 33.1657 30.1733H6.75909V30.1711C5.07156 30.1311 3.71588 28.7519 3.71582 27.0547V22.1381C3.71594 20.4158 5.11211 19.0195 6.83436 19.0195H7.32381Z" stroke={fill} strokeWidth="1.2"/>
            <line x1="9.75465" y1="30.5008" x2="7.62782" y2="33.9509" stroke={fill} stroke-width="1.5" stroke-linecap="round"/>
            <line x1="0.75" y1="-0.75" x2="4.80305" y2="-0.75" transform="matrix(0.524747 0.851258 0.851258 -0.524747 30.4902 29.4688)" stroke={fill} stroke-width="1.5" stroke-linecap="round"/>
        </svg>
    );
};
